import { convertTimeStamp } from "utility/functions/convertTimestamp";
import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";

const RedDot = () => (
  <span className="inline-block h-[8px] w-[8px] bg-red-600 mr-1 rounded-full"></span>
);
const GreenDot = () => (
  <span className="inline-block h-[8px] w-[8px] bg-green-600 mr-1 rounded-full"></span>
);

export const columns = [
  //   {
  //     title: "公關票",
  //     dataIndex: "isOfficial",
  //     key: "isOfficial",
  //   },
  //   {
  //     title: "狀態",
  //     dataIndex: "disabled",
  //     key: "disabled",
  //   },
  //   {
  //     title: '認證電話',
  //     dataIndex: 'phoneConfirmed',
  //     key: 'phoneConfirmed',
  //   },
  {
    title: (
      <>
        姓名
        <Tooltip title="紅色：會員未認證Email" className="ml-1">
          <QuestionCircleOutlined />
        </Tooltip>
      </>
    ),
    dataIndex: "name",
    key: "name",
    render: (text, record) =>
      record?.emailConfirmed ? (
        <>
          <GreenDot />
          {text}
        </>
      ) : (
        <>
          <RedDot />
          {text}
        </>
      ),
  },
  {
    title: "帳號",
    dataIndex: "username",
    key: "username",
    width: 90,
  },
  //   {
  //     title: "Email",
  //     dataIndex: "email",
  //     key: "email",
  //   },

  {
    title: "電話",
    dataIndex: "phone",
    key: "phone",
  },

  {
    title: "最後登入時間",
    dataIndex: "lastSignInDate",
    key: "lastSignInDate",
    render: (text) => (text ? convertTimeStamp(text) : "-"),
  },
  {
    title: "創建日期",
    dataIndex: "creationDate",
    key: "creationDate",
    render: (text) => convertTimeStamp(text),
  },
];
